<template>
  <img v-bind="logo" :alt="logo?.alt" />
</template>

<script setup lang="ts">
import useMeta from '@/services/useMeta';

const { logo } = useMeta();
</script>
